import {
    selectEffectiveCompanyId,
    selectEffectiveDisplayName,
    selectEffectiveUserId,
    selectEffectiveUserType,
} from "../../../../modules/context/contextSelectors"
import { UserType } from "../../../../modules/login/loginTypes"
import { useAppSelector } from "../../../../modules/store/storeHooks"

export type EffectiveUserSnapshot = {
    userType: UserType
    isUserType: boolean
    userId: number
    companyId: number
    displayName: string
}

export function useEffectiveUserSnapshot(): EffectiveUserSnapshot {
    const userType = useAppSelector(selectEffectiveUserType)!
    const isUserType = userType === UserType.USER

    const userId = isUserType ? useAppSelector(selectEffectiveUserId) || 0 : 0
    const companyId = useAppSelector(selectEffectiveCompanyId) || 0
    const displayName = isUserType ? useAppSelector(selectEffectiveDisplayName) || "" : ""

    return { userType, isUserType, userId, companyId, displayName }
}
